export enum AnalyticsEvents {
  AgentVisited = "Agent visited",
  MeetingJoined = "Meeting joined",
  GreetingMessage = "Greeting message",
  QuestionAsked = "Question asked",
  AnswerProvided = "Answer provided",
  CallEnded = "Call ended",
  Rejoined = "Rejoined",
  Feedback = "Feedback",
  IdleTimeout = "Idle timeout",
  AvatarVideoSummary = "Avatar video summary",
}
